const SettingsAlertLevelDetails = () => import('frontend/pages/settings/alerts/SettingsAlertLevelDetails')
const SettingsAlertLevels = () => import('frontend/pages/settings/alerts/SettingsAlertLevels')
const SettingsAlerts = () => import('frontend/pages/settings/alerts/SettingsAlerts')
const SettingsAlertsChartsConfig = () => import('frontend/pages/settings/alerts/SettingsAlertsChartsConfig')
const SettingsAlertTemplateDetails = () => import('frontend/pages/settings/alerts/SettingsAlertTemplateDetails')
const SettingsAlertTemplates = () => import('frontend/pages/settings/alerts/SettingsAlertTemplates')
const HeaderFactoryStructure = () => import('frontend/components/core/HeaderFactoryStructure')

import { ACTIONS } from 'frontend/constants/callers'
import { ALERTS_SOURCE } from 'frontend/constants/alerts'
import { SETTINGS_CARDS_TOKENS } from 'frontend/constants/settings'

export default [
  {
    path: '/settings/alerts',
    name: 'settings-alerts',
    component: SettingsAlerts,
    redirect: { name: SETTINGS_CARDS_TOKENS.alertLevels.name },
    children: [
      {
        path: 'levels',
        name: SETTINGS_CARDS_TOKENS.alertLevels.name,
        components: {
          default: SettingsAlertLevels,
        },
        props: {
          default: { source: ALERTS_SOURCE },
        },
      },
      {
        path: 'levels/:id',
        name: `${SETTINGS_CARDS_TOKENS.alertLevels.name}-details`,
        components: {
          default: SettingsAlertLevelDetails,
        },
      },
      {
        path: 'templates',
        name: SETTINGS_CARDS_TOKENS.alertTemplates.name,
        components: {
          header: HeaderFactoryStructure,
          default: SettingsAlertTemplates,
        },
        props: {
          header: { source: ALERTS_SOURCE, caller: ACTIONS },
          default: { source: ALERTS_SOURCE },
        },
      },
      {
        path: 'templates/:id',
        name: `${SETTINGS_CARDS_TOKENS.alertTemplates.name}-details`,
        components: {
          default: SettingsAlertTemplateDetails,
        },
      },
      {
        path: 'charts-config',
        name: SETTINGS_CARDS_TOKENS.alertChartsTablesConfiguration.name,
        components: {
          default: SettingsAlertsChartsConfig,
        },
        props: { default: { source: ALERTS_SOURCE } },
      },
    ],
  },
]
